import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FlexCustomersComponent } from './flex-customers.component';

const routes: Routes = [{ path: '', component: FlexCustomersComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FlexCustomersRoutingModule {}
